import { useState, useCallback } from "react";


export const useAgentSearchUIState = () => {
  const [errorSnackbar, setErrorSnackbar] = useState({
    open: false,
    message: "",
  });

  const openErrorSnackbar = useCallback(
    (message) => setErrorSnackbar({ open: true, message }),
    [],
  );

  const closeErrorSnackbar = useCallback(
    () => setErrorSnackbar({ open: false, message: "" }),
    [],
  );

  return {
    errorSnackbar,
    openErrorSnackbar,
    closeErrorSnackbar,
  };
};
